"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assetsMapper = exports.AssetsMapper = void 0;
const models_1 = require("../models");
const responses_1 = require("../responses");
const base_mapper_1 = require("./base-mapper");
class AssetsMapper extends base_mapper_1.BaseMapper {
    mapListingAssetsResponse(response) {
        const pagination = super.mapPagination(response.data.pagination);
        const items = response.data.assets.map(m => this.mapAsset(m));
        return new responses_1.AssetResponses.AssetsListResponse(super.mapResponseDebug(response), response.data, {
            pagination: pagination,
            items: items
        });
    }
    mapViewAssetResponse(response) {
        return new responses_1.AssetResponses.ViewAssetResponse(super.mapResponseDebug(response), response.data, this.mapAsset(response.data));
    }
    mapUploadBinaryFileResponse(response) {
        return new responses_1.AssetResponses.UploadBinaryFileResponse(super.mapResponseDebug(response), response.data, this.mapAssetReference(response.data));
    }
    mapAddAssetResponse(response) {
        return new responses_1.AssetResponses.AddAssetResponse(super.mapResponseDebug(response), response.data, this.mapAsset(response.data));
    }
    mapUpdateAssetResponse(response) {
        return new responses_1.AssetResponses.UpdateAssetResponse(super.mapResponseDebug(response), response.data, this.mapAsset(response.data));
    }
    mapUpsertAssetResponse(response) {
        return new responses_1.AssetResponses.UpsertAssertResponse(super.mapResponseDebug(response), response.data, this.mapAsset(response.data));
    }
    mapAssetReference(rawFileReference) {
        return new models_1.AssetModels.AssetFileReference({
            id: rawFileReference.id,
            type: rawFileReference.type
        });
    }
    mapAsset(rawAsset) {
        return new models_1.AssetModels.Asset({
            descriptions: rawAsset.descriptions.map(m => new models_1.AssetModels.AssetFileDescription({
                description: m.description,
                language: super.mapReference(m.language)
            })),
            externalId: rawAsset.external_id,
            fileName: rawAsset.file_name,
            fileReference: this.mapAssetReference(rawAsset.file_reference),
            id: rawAsset.id,
            url: rawAsset.url,
            imageHeight: rawAsset.image_height,
            imageWidth: rawAsset.image_width,
            lastModified: new Date(rawAsset.last_modified),
            size: rawAsset.size,
            title: rawAsset.title,
            type: rawAsset.type,
            folder: rawAsset.folder,
            _raw: rawAsset
        });
    }
}
exports.AssetsMapper = AssetsMapper;
exports.assetsMapper = new AssetsMapper();
//# sourceMappingURL=assets-mapper.js.map